import React from "react";

function Asterisk() {
  return <span className="text-red-500 mx-1">*</span>;
}

export default Asterisk;
